import React, {useState, createContext, useRef} from 'react'

export const ErrorContext = createContext()

export const ErrorProvider = (props) => {
    const[errorState, setErrorState] = useState({})
    const fieldRefs = useRef({});

    const scrollToFirstError = () => {
        const firstErrorKey = Object.keys(errorState).find((key) => {
            const value = errorState[key];

            return Array.isArray(value)
                ? value.some((v) => v !== "")
                : value !== "";
        });

        if (!firstErrorKey) return;

        const el = fieldRefs.current[firstErrorKey];

        if (el) {
            const headerOffset = 120; // your header height
            const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });

            const input = el.querySelector(
                "input, select, textarea, button"
            );

            input?.focus();
        }
    };

    const scrollFieldToTop = (key) => {
        // run only on mobile
        const isMobile = window.matchMedia("(max-width: 768px)").matches;

        if (!isMobile) return;

        const el = fieldRefs.current[key];
        if (!el) return;

        const doScroll = () => {
            const headerOffset = 120;
            const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        };
        requestAnimationFrame(() => requestAnimationFrame(doScroll));
        setTimeout(doScroll, 100);
    };
    return (
        <ErrorContext.Provider value={[
            errorState,
            setErrorState,
            fieldRefs,
            scrollToFirstError,
            scrollFieldToTop
        ]}>
            {props.children}
        </ErrorContext.Provider>
    )
}